// frontend/src/components/leveling/LevelUpToast.js
import React, { useEffect } from "react";
import { toast } from "sonner";
import { tierDisplay } from "../../lib/leveling";

/**
 * Mounts in App.js. Listens for `level_up` notifications and shows a toast.
 *
 * `notifications` prop: array of recent notifications from your existing
 * notifications context. The component fires once per new id seen.
 */
export default function LevelUpToast({ notifications }) {
  useEffect(() => {
    if (!Array.isArray(notifications)) return;
    const seen = new Set(JSON.parse(sessionStorage.getItem("lvl_toast_seen") || "[]"));
    let dirty = false;
    for (const n of notifications) {
      if (n.type !== "level_up" || seen.has(n.id)) continue;
      const tier = n.metadata?.tier || "rookie";
      const td = tierDisplay(tier);
      toast.success(`Level ${n.metadata?.level ?? ""}!`, {
        description: "Keep showing up.",
        duration: 2500,
        style: { borderColor: td.color },
      });
      seen.add(n.id);
      dirty = true;
    }
    if (dirty) sessionStorage.setItem("lvl_toast_seen", JSON.stringify([...seen]));
  }, [notifications]);
  return null;
}
